import { useState } from 'react';
import { BarChart3, Plus, X, Check } from 'lucide-react';
import ModalShell from '../ui/ModalShell';
import { SECTION_COLOR, hlavicky } from './komunikace';

/** Nová anketa do konverzace — `ModalShell`. */
export default function NovaAnketa({ konverzaceId, isDark, onClose, onHotovo }) {
    const [otazka, setOtazka] = useState('');
    const [moznosti, setMoznosti] = useState(['', '']);
    const [vice, setVice] = useState(false);
    const [anonymni, setAnonymni] = useState(false);
    const [ukladam, setUkladam] = useState(false);
    const [chyba, setChyba] = useState(null);

    const platne = moznosti.map(m => m.trim()).filter(Boolean);
    const lze = otazka.trim() && platne.length >= 2 && !ukladam;

    const ulozit = async () => {
        if (!lze) return;
        setUkladam(true);
        setChyba(null);
        try {
            const res = await fetch('/api/ankety', { method: 'POST', headers: hlavicky(), body: JSON.stringify({ konverzace_id: konverzaceId, otazka: otazka.trim(), moznosti: platne, vice, anonymni }) });
            const d = await res.json().catch(() => ({}));
            if (!res.ok) { setChyba(d.error || 'Nepodařilo se.'); return; }
            onHotovo();
        } catch { setChyba('Chyba sítě.'); } finally { setUkladam(false); }
    };

    const hrana = isDark ? 'rgba(255,255,255,0.12)' : 'var(--border-default)';
    const pole = { width: '100%', height: 42, borderRadius: 8, padding: '0 12px', outline: 'none', fontSize: 15, background: isDark ? 'rgba(0,0,0,0.35)' : 'var(--surface-raised)', border: `1px solid ${hrana}`, color: 'var(--text-primary)' };
    const popisek = { fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--text-muted)', margin: '14px 0 6px' };
    const Prepinac = ({ on, onClick, text }) => (
        <button type="button" onClick={onClick} className="flex items-center gap-2" style={{ background: 'none', border: 'none', padding: '6px 0', cursor: 'pointer', color: 'var(--text-primary)', fontSize: 14 }}>
            <span style={{ width: 20, height: 20, borderRadius: 5, border: `1.5px solid ${on ? SECTION_COLOR : hrana}`, background: on ? SECTION_COLOR : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{on && <Check size={14} color="#fff" />}</span>
            {text}
        </button>
    );

    return (
        <ModalShell onClose={onClose} isDark={isDark} nadpis="Anketa" ikona={BarChart3} barva={SECTION_COLOR} sirka={460}
            paticka={(
                <div className="flex items-center gap-2">
                    {chyba && <span className="text-xs flex-1" style={{ color: '#EF4444' }}>{chyba}</span>}
                    <button type="button" onClick={ulozit} disabled={!lze} className="rounded-lg font-semibold ml-auto"
                        style={{ height: 44, padding: '0 20px', background: SECTION_COLOR, color: '#fff', border: 'none', cursor: lze ? 'pointer' : 'not-allowed', opacity: lze ? 1 : 0.45 }}>
                        {ukladam ? 'Odesílám…' : 'Poslat anketu'}
                    </button>
                </div>
            )}>
            <div style={{ padding: '0 16px 16px' }}>
                <p style={popisek}>Otázka</p>
                <input value={otazka} onChange={e => setOtazka(e.target.value)} maxLength={300} placeholder="Např. Kdy uděláme teambuilding?" style={pole} autoFocus />
                <p style={popisek}>Možnosti</p>
                <div className="flex flex-col" style={{ gap: 6 }}>
                    {moznosti.map((m, i) => (
                        <div key={i} className="flex gap-2">
                            <input value={m} onChange={e => setMoznosti(prev => prev.map((x, j) => (j === i ? e.target.value : x)))} maxLength={120} placeholder={`Možnost ${i + 1}`} style={pole} />
                            {moznosti.length > 2 && (
                                <button type="button" onClick={() => setMoznosti(prev => prev.filter((_, j) => j !== i))} aria-label="Odebrat možnost"
                                    style={{ width: 42, height: 42, flexShrink: 0, borderRadius: 8, border: `1px solid ${hrana}`, background: 'transparent', color: 'var(--text-secondary)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}><X size={15} /></button>
                            )}
                        </div>
                    ))}
                </div>
                {moznosti.length < 10 && (
                    <button type="button" onClick={() => setMoznosti(prev => [...prev, ''])} className="flex items-center gap-1 text-sm font-semibold"
                        style={{ marginTop: 8, background: 'none', border: 'none', padding: 0, color: SECTION_COLOR, cursor: 'pointer' }}><Plus size={15} /> Přidat možnost</button>
                )}
                <div style={{ marginTop: 12 }}>
                    <Prepinac on={vice} onClick={() => setVice(v => !v)} text="Jde vybrat víc možností" />
                    <Prepinac on={anonymni} onClick={() => setAnonymni(v => !v)} text="Anonymní — nebude vidět, kdo jak hlasoval" />
                </div>
            </div>
        </ModalShell>
    );
}
